import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import { getPluralKey } from '@common/helpers/getPluralKey';
import { IBookWithProgress } from '@common/models/Books/Book';

import BooksModal from '../BooksModal';
import {
	BookArrayItemImagesWrap,
	BookItemImg,
	BookItemInfoSubTitle,
	BookItemInfoTitle,
	BookItemInfoWrap,
	BookItemWrap,
} from './style';

interface PropsType {
	books: IBookWithProgress[];
	programName: string;
}

function BookArrayItem({ books, programName }: PropsType) {
	const [isOpen, setIsOpen] = useState(false);
	const { t } = useTranslation();

	const booksLength = books.length;

	const handleToggleMenuVisibility = (value: boolean) => () => {
		setIsOpen(value);
	};

	return (
		<>
			<BookItemWrap onClick={handleToggleMenuVisibility(true)}>
				<BookArrayItemImagesWrap>
					{books.slice(0, 4).map((book, index) => (
						<BookItemImg key={index} src={book?.image_url} alt="Book" />
					))}
				</BookArrayItemImagesWrap>
				<BookItemInfoWrap>
					<Box>
						<BookItemInfoTitle variant="subtitle1">{programName}</BookItemInfoTitle>
						<BookItemInfoSubTitle
							variants={{ sm: 'body3' }}
							variant="body2"
							textColor="secondary"
							lineClamp={{ xs: 3 }}
						>
							{t(`resources.length.${getPluralKey(booksLength)}`, { count: booksLength })}
						</BookItemInfoSubTitle>
					</Box>
				</BookItemInfoWrap>
			</BookItemWrap>
			<BooksModal
				books={books}
				open={isOpen}
				onClose={handleToggleMenuVisibility(false)}
				title={programName}
			/>
		</>
	);
}

export default BookArrayItem;
